"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var Badge_1 = __importDefault(require("../../Badge"));
var styles_1 = require("./styles");
var MaterialIcon_1 = __importDefault(require("../../MaterialIcon"));
var styles_2 = require("../styles");
var Tab = function (_a) {
    var _b;
    var tab = _a.tab, tabIndex = _a.tabIndex, activeTabIndex = _a.activeTabIndex, onTabChangeHandler = _a.onTabChangeHandler;
    var tabContent = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styles_1.TabLabel, { children: tab.label }), tab.badge !== 0 && tab.badge && ((0, jsx_runtime_1.jsx)(styles_1.BadgeCount, { children: (0, jsx_runtime_1.jsx)(Badge_1.default, __assign({ variant: "primary" }, { children: tab.badge })) })), tab.iconName && ((0, jsx_runtime_1.jsx)(styles_2.IconWrapper, { children: (0, jsx_runtime_1.jsx)(MaterialIcon_1.default, { name: tab.iconName }) }))] }));
    var handleKeyDown = function (e) {
        var _a;
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onTabChangeHandler === null || onTabChangeHandler === void 0 ? void 0 : onTabChangeHandler((_a = tab.index) !== null && _a !== void 0 ? _a : 0);
        }
    };
    if (tab.path) {
        return ((0, jsx_runtime_1.jsx)(styles_1.TabContainerNav, __assign({ replace: true, role: "tab", to: tab.path, end: (_b = tab.end) !== null && _b !== void 0 ? _b : false, "data-testid": "tab-".concat(tab.path.replace('/', '')), tabIndex: 0, onKeyDown: function (e) {
                if (e.key === ' ') {
                    e.preventDefault();
                    e.currentTarget.click();
                }
            } }, { children: tabContent })));
    }
    return ((0, jsx_runtime_1.jsx)(styles_1.TabContainerDiv, __assign({ className: (0, classnames_1.default)({
            active: tabIndex === activeTabIndex,
        }), role: "tab", "data-testid": "tab-".concat(tab.index), onClick: function () { var _a; return onTabChangeHandler === null || onTabChangeHandler === void 0 ? void 0 : onTabChangeHandler((_a = tab.index) !== null && _a !== void 0 ? _a : 0); }, onKeyDown: handleKeyDown, tabIndex: 0, "aria-selected": tabIndex === activeTabIndex }, { children: tabContent })));
};
exports.default = Tab;
